export default __webpack_public_path__ + "static/media/icon_defender.0dc3ebfc.png";